import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/static/ToTop.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-00af4ce5")

_pushScopeId("data-v-00af4ce5")
const _hoisted_1 = { class: "back-top" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode("img", {
          class: "back-top-arrow",
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goTop && _ctx.goTop(...args)))
        })
      ], 512), [
        [_vShow, _ctx.isDisplay]
      ])
    ]),
    _: 1
  }))
})